import * as React from "react";
import "./GenericCheckBoxInput.css";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion, PossibleAnswerId } from "../../messages/HR";
import { StatusComponent } from "../widgets/StatusComponent";
import { Checkbox } from "@blueprintjs/core";
import { GenericInputHeader } from "./GenericInputHeader";
import { HRQuestionTemplateId } from "../../messages/ObjectIds";
import { Globals } from "../../Globals";

interface GenericCheckBoxInputProps {
    hrCheckBoxQuestionWithStatus: HRQuestionWithStatus<HRQuestion.CheckboxQuestion | HRQuestion.FreeTextQuestion>;
    isHidden: boolean;
    onChange: (newVal: PossibleAnswerId, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericCheckBoxInput extends React.Component<GenericCheckBoxInputProps> {
    constructor(props: GenericCheckBoxInputProps) {
        super(props);
        if (props.hrCheckBoxQuestionWithStatus.question.chosenAnswerIds !== null && props.hrCheckBoxQuestionWithStatus.question.chosenAnswerIds.length > 0) {
            return;
        }

        const lastPick = Globals.getAnswerByTemplateId(props.hrCheckBoxQuestionWithStatus.question.textId);
        if (lastPick !== null) {
            for (const pick of lastPick) {
                this.props.onChange(pick, props.hrCheckBoxQuestionWithStatus.question.id);
            }
            this.props.onBlur(props.hrCheckBoxQuestionWithStatus.question.id);
        }
    }

    handleChange(answerId: PossibleAnswerId, questionId: HRQuestionId) {
        this.props.onChange(answerId, questionId);
        this.props.onBlur(questionId);
    }

    render() {
        const question: HRQuestion.CheckboxQuestion | HRQuestion.FreeTextQuestion = this.props.hrCheckBoxQuestionWithStatus.question;
        const status = this.props.hrCheckBoxQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                {question.type === "FreeText" ?
                    <div className="GenericInputHeader__container">
                        <div dangerouslySetInnerHTML={{ __html: question.questionText }}/>
                        <StatusComponent questionStatus={status}/>
                    </div> :
                    <GenericInputHeader status={status} questionText={question.questionText}/>
                }
                {question.possibleAnswers.map((answer) => {
                    return (
                        <div className="GenericCheckBoxInput__item" key={"" + answer.id}>
                            <Checkbox
                                checked={question.chosenAnswerIds !== null && question.chosenAnswerIds.indexOf(answer.id as any) !== -1}
                                label={answer.text}
                                onChange={() => this.handleChange(answer.id, question.id)}
                                required={question.isMandatory}
                                id={HRQuestionTemplateId.unwrap(question.textId)}
                            />
                        </div>
                    );
                })}
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericCheckBoxInput.tsx